// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimOffsetDto
 */
export interface IClaimOffsetDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimOffsetDto
     */
    donor_claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimOffsetDto
     */
    recipient_claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimOffsetDto
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimOffsetDto
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the IClaimOffsetDto interface.
 */
export function instanceOfIClaimOffsetDto(value: object): value is IClaimOffsetDto {
    return true;
}

export function IClaimOffsetDtoFromJSON(json: any): IClaimOffsetDto {
    return IClaimOffsetDtoFromJSONTyped(json, false);
}

export function IClaimOffsetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimOffsetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'donor_claim_id': json['donor_claim_id'] == null ? undefined : json['donor_claim_id'],
        'recipient_claim_id': json['recipient_claim_id'] == null ? undefined : json['recipient_claim_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IClaimOffsetDtoToJSON(json: any): IClaimOffsetDto {
    return IClaimOffsetDtoToJSONTyped(json, false);
}

export function IClaimOffsetDtoToJSONTyped(value?: IClaimOffsetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'donor_claim_id': value['donor_claim_id'],
        'recipient_claim_id': value['recipient_claim_id'],
        'amount': value['amount'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

